import { call } from "redux-saga/effects";
import graphAuthSaga from "../redux/sagas/graphAuthSaga";

const GRAPH_ENDPOINT = "https://graph.microsoft.com/v1.0";

export default function* sendEmailUsingGraphSaga(visitors, customerName, emailSubject) {
  try {
    const accessToken = yield call(graphAuthSaga);

    if (accessToken) {
      for (const visitor of visitors) {
        const attachments = [
          {
            "@odata.type": "#microsoft.graph.fileAttachment",
            name: "qr.png",
            contentId: "qr_cid",
            isInline: true,
            contentBytes: visitor.qr_code_base64,
          },
          {
            "@odata.type": "#microsoft.graph.fileAttachment",
            name: "eportier.png",
            contentId: "eportier_cid",
            isInline: true,
            contentBytes:
              "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",
  
          },
        ];

        // Logo nur anhängen, wenn ein <img> mit src="cid:logo_cid" und alt="Logo" vorkommt
        const logoImgRegex = /<img[^>]*src=["']cid:logo_cid["'][^>]*alt=["']logo["'][^>]*>/i;
        if (logoImgRegex.test(visitor.email_with_qr_code)) {
          attachments.push({
            "@odata.type": "#microsoft.graph.fileAttachment",
            name: "logo.png",
            contentId: "logo_cid",
            isInline: true,
            contentBytes: visitor.logo_base64,
          });
        }

        const email = {
          message: {
            // Pro Visitor kann eine eigene Vorlage greifen (Tag-Bindung, z.B.
            // Sprache) — dann kommt der passende Betreff am Visitor mit.
            subject: visitor.email_subject || emailSubject,
            body: {
              contentType: "HTML",
              content: visitor.email_with_qr_code,
            },
            toRecipients: [{ emailAddress: { address: visitor.email } }],
            attachments: attachments,
          },
        };

        const url = `${GRAPH_ENDPOINT}/me/sendMail`;
        const response = yield call(fetch, url, {
          method: "POST",
          headers: {
            Authorization: `Bearer ${accessToken}`,
            "Content-Type": "application/json",
          },
          body: JSON.stringify(email),
        });

        if (!response.ok) {
          const errorText = yield response.text();
          console.error("Fehler beim Senden der E-Mail über die Graph API:", errorText);
          throw new Error(`Graph API Fehler: ${response.status}`);
        }
      }
    }
  } catch (error) {
    console.error("Fehler bei der Authentifizierung oder beim E-Mail-Versand", error);
    throw error;
  }
}

export function* sendCancellationEmailsUsingGraphSaga(cancellationEmails) {
  try {
    const accessToken = yield call(graphAuthSaga);

    if (accessToken) {
      for (const mail of cancellationEmails) {
        const email = {
          message: {
            subject: mail.subject,
            body: {
              contentType: "HTML",
              content: mail.html,
            },
            toRecipients: [{ emailAddress: { address: mail.email } }],
          },
        };

        const url = `${GRAPH_ENDPOINT}/me/sendMail`;
        const response = yield call(fetch, url, {
          method: "POST",
          headers: {
            Authorization: `Bearer ${accessToken}`,
            "Content-Type": "application/json",
          },
          body: JSON.stringify(email),
        });

        if (!response.ok) {
          const errorText = yield response.text();
          console.error("Fehler beim Senden der Absage-E-Mail über die Graph API:", errorText);
          throw new Error(`Graph API Fehler: ${response.status}`);
        }
      }
    } else {
      throw new Error("Failed to fetch access token for Graph API.");
    }
  } catch (error) {
    console.error("Fehler bei der Authentifizierung oder beim Absage-E-Mail-Versand", error);
    throw error;
  }
}
